import type { FC, ReactElement } from 'react';
import type { RouteProps } from 'react-router';

import { Button, Result } from 'antd';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';

import { useLocale } from '../locales';

export type PrivateRouteProps = RouteProps & {
  element: ReactElement;
  roles?: string[];
};

const PrivateRoute: FC<PrivateRouteProps> = ({ element, roles }) => {
  const { logged, role } = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const { formatMessage } = useLocale();
  const location = useLocation();

  if (!logged) {
    return (
      <Result
        title="Not found"
        subTitle={formatMessage({ id: 'gloabal.tips.unauthorized' })}
        extra={
          <Button
            type="primary"
            onClick={() =>
              navigate(`/login?from=${encodeURIComponent(location.pathname)}`, {
                replace: true,
              })
            }
          >
            {formatMessage({ id: 'gloabal.tips.goToLogin' })}
          </Button>
        }
      />
    );
  }

  if (roles && !roles.includes(role)) {
    return (
      <Result
        status="404"
        title="404"
        subTitle={formatMessage({ id: 'gloabal.tips.unauthorized' })}
        extra={
          <Button type="primary" onClick={() => navigate('/', { replace: true })}>
            {formatMessage({ id: 'gloabal.tips.goToLogin' })}
          </Button>
        }
      />
    );
  }

  return element;
};

export default PrivateRoute;
